'use strict';

function onEntry(entry) {
  entry.forEach(change => {
    if (change.isIntersecting) {
      change.target.classList.add('element-show');
    }
  });
}

const options = { threshold: [0.3] };
const observer = new IntersectionObserver(onEntry, options);
const elements = document.querySelectorAll('.element-animation');

for (const elm of elements) {
  observer.observe(elm);
}
